import { User, Expense, TripConfig } from './types';

// TripConfig imported from types.ts

export const USERS: User[] = [];

export const TRIP_CONFIG: TripConfig = {
  id: 'default-trip',
  title: "",
  startDate: '',
  endDate: '',
  adminIds: [],
  ownerId: '',
  memberIds: [],
  inviteEmails: [],
  homeLocation: '',
  homeCountry: '',
  destinations: [],
  travellers: [],
  baseCurrency: 'USD',
  checklist: [
    { item: 'Check passport validity', checked: false },
    { item: 'Book hire car', checked: false },
    { item: 'Pack universal power adaptor', checked: false },
  ],
};

export function userById(id: string): User {
  return USERS.find(u => u.id === id) || { id, name: "User", email: "", initials: "??", color: "#666", emoji: "👤", imgSrc: null };
}

export const EXPENSES_INIT: Expense[] = [];
